import SeekerShell from '../../../layouts/SeekerShell.vue';
import ApprenticeShell from '../../../layouts/ApprenticeShell.vue';
import SkillsPassport from '../views/SkillsPassportLanding';
import SearchCareer from '../views/SearchCareer';
import SkillsPassportDetails from '../views/SkillsPassportDetails';
import SkillsPassportList from '../views/SkillsPassportList';

export default [
  {
    path: '/',
    name: 'SkillPassport',
    component: SeekerShell,
    meta: {
      requiredRole: process.env.VUE_APP_ROLE_JOB_SEEKER,
    },
    children: [
      {
        path: 'js-skills-passport/landing',
        name: 'JobSeekerSkillsPassport',
        component: SkillsPassport
      },
      {
        path: 'js-skills-passport/search-skills',
        name: 'JobSeekerSearchCareer',
        component: SearchCareer,
        meta: {
          role: process.env.VUE_APP_ROLE_JOB_SEEKER,
        },
      },
      {
        path: 'js-skills-passport/skills-details/:onetcode',
        name: 'JobSeekerSkillsPassportDetails',
        component: SkillsPassportDetails,
        meta: {
          role: process.env.VUE_APP_ROLE_JOB_SEEKER,
        },
      },
      {
        path: 'js-skills-passport/skills-list',
        name: 'JobSeekerSkillsPassportList',
        component: SkillsPassportList,
        meta: {
          role: process.env.VUE_APP_ROLE_JOB_SEEKER,
        },
      },
    ]
  },
  {
    path: '/',
    name: 'SkillPassport',
    component: ApprenticeShell,
    meta: {
      requiredRole: process.env.VUE_APP_ROLE_APPRENTICE,
    },
    children: [
      {
        path: 'a-skills-passport/landing',
        name: 'ApprenticeSkillsPassport',
        component: SkillsPassport,
        meta: {
          role: process.env.VUE_APP_ROLE_APPRENTICE,
        },
      },
      {
        path: 'a-skills-passport/search-skills',
        name: 'ApprenticeSearchCareer',
        component: SearchCareer,
        meta: {
          role: process.env.VUE_APP_ROLE_APPRENTICE,
        },
      },
      {
        path: 'a-skills-passport/skills-details/:onetcode',
        name: 'ApprenticeSkillsPassportDetails',
        component: SkillsPassportDetails,
        meta: {
          role: process.env.VUE_APP_ROLE_APPRENTICE,
        },
      },
      {
        path: 'a-skills-passport/skills-list',
        name: 'ApprenticeSkillsPassportList',
        component: SkillsPassportList,
        meta: {
          role: process.env.VUE_APP_ROLE_APPRENTICE,
        },
      },
    ]
  },
];
